import * as React from "react";
import TextareaAutosize from "react-textarea-autosize";
import styled from "styled-components";

const STextArea = styled(TextareaAutosize)``;

export default function TextArea(props) {
  return <STextArea {...props} />;
}
